import { createFeatureSelector, createSelector } from '@ngrx/store';
import { createItemSelectorReducer, createItemSelectorState, IItemSelectorCategory, IItemSelectorItem } from './reducer';

export function createItemSelectorSelectors<
  I extends IItemSelectorItem,
  C extends IItemSelectorCategory<I>>(featureSelectorName: string) {
  const TState = () => createItemSelectorState<I, C>();

  const featureSelector = createFeatureSelector<ReturnType<typeof TState>>(featureSelectorName);

  return {
    featureSelector,

    items: createSelector(
      featureSelector,
      state => state.items
    ),

    categories: createSelector(
      featureSelector,
      state => state.categories
    ),

    selectedCategoryIndex: createSelector(
      featureSelector,
      state => state.selectedCategoryIndex
    ),

    selectedCategory: createSelector(
      featureSelector,
      state => state.selectedCategory
    ),

    selectedCategoryItems: createSelector(
      featureSelector,
      state => state.selectedCategoryItems
    ),

    selectedItemIndex: createSelector(
      featureSelector,
      state => state.selectedItemIndex
    ),

    selectedItem: createSelector(
      featureSelector,
      state => state.selectedItem
    ),
  };
}
